import { render, staticRenderFns } from "./duplicate.vue?vue&type=template&id=c388117c&scoped=true&"
import script from "./duplicate.vue?vue&type=script&lang=js&"
export * from "./duplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c388117c",
  null
  
)

export default component.exports